import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import "../index.css"

import _ from 'lodash'

// Inputs
import { Button, TextInputField, TextAreaField, CheckboxField } from '../../../helpers'

import Loading from "../../../common/Loading"
import CopyToClipboard from '../../../common/CopyToClipboard'

import { forceCloseBuyerPO } from '../../../services/api/buyerPO'

// Redux
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchBuyerPOs } from '../../../services/redux/reducers/buyerPO/buyerPO'

import RemarksDialog from '../../../common/RemarksDialog'

import { updatePOScheduleItemsByBuyerPOItemIds, getPOScheduleItemsRaw } from '../../../services/api/poScheduleItem'


const ForceClose = (props) => {
    const { buyerPOs, buyerPOItems, materialDetails, materialBrands, deliveryChallans, dispatchNotes, dispatchNoteItems, stocDocs, setIsForceCloseModalVisible } = props

    const [isLoading, setIsLoading] = useState(false)
    const [remarks, setRemarks] = useState("")
    const [relatedDeliveryChallans, setRelatedDeliveryChallans] = useState([])
    const [ignoreOpenPORemarksDialogVisible, setIgnoreOpenPORemarksDialogVisible] = useState(false)
    const [forseCloseRemarksDialogVisible, setForseCloseRemarksDialogVisible] = useState(false)
    const [selectedBuyerPOItemIds, setSelectedBuyerPOItemIds] = useState([])
    const [poScheduleItems, setPOScheduleItems] = useState([])

    const searchParams = useSelector(state => state.buyerPOData.searchParams)
    const paginationParams = useSelector(state => state.buyerPOData.paginationParams)

    const dispatch = useDispatch()

    useEffect(() => {
        let relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOId === buyerPOs[0]?.buyerPOId && eachDispatchNoteItem?.statusId === 1)
        let relatedDispatchNotes = []
        relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
            const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
            if (relatedDispatchNote?.dispatchNoteId){
                relatedDispatchNotes.push(relatedDispatchNote)
            }
        })
        relatedDispatchNotes = _.uniqBy(relatedDispatchNotes, "dispatchNoteId")
        
        let relatedDeliveryChallans = []
        relatedDispatchNotes?.map(eachDispatchNote => {
            const relatedDeliveryChallan = deliveryChallans?.find(eachDeliveryChallan => eachDeliveryChallan?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
            if (relatedDeliveryChallan?.deliveryChallanId){
                relatedDeliveryChallans.push(relatedDeliveryChallan)
            }
        })
        setRelatedDeliveryChallans(relatedDeliveryChallans)
    }, [deliveryChallans])

    useEffect(() => {
        let buyerPOItemIds = buyerPOItems.map(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId)
        if(buyerPOItemIds.length){
            getPOScheduleItems(buyerPOItemIds)
        }
    }, [buyerPOItems])

    const getPOScheduleItems = async(buyerPOItemIds) => {
        setIsLoading(true)
        const poScheduleItemsResponse = await getPOScheduleItemsRaw({buyerPOItemIds, paginator: false, limitedPagination: false})
        console.log("poScheduleItems-res", poScheduleItemsResponse)
        setIsLoading(false)
        if(poScheduleItemsResponse.failure){
            dispatch(raiseToast({ severity: 'error', summary: poScheduleItemsResponse.data?.error, detail: "poScheduleItem error", life: 3000 }))
        }
        let relatedPOScheduleItems = poScheduleItemsResponse.data?.data
        if(relatedPOScheduleItems && relatedPOScheduleItems.length){
            setPOScheduleItems([...relatedPOScheduleItems])
        }
    }

    const handleSubmit = async (remarks) => {
        let relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOId === buyerPOs[0]?.buyerPOId && eachDispatchNoteItem?.statusId === 1)
        let relatedDispatchNotes = []
        relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
            const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
            if (relatedDispatchNote?.dispatchNoteId){
                relatedDispatchNotes.push(relatedDispatchNote)
            }
        })
        relatedDispatchNotes = _.uniqBy(relatedDispatchNotes, "dispatchNoteId")
        
        let relatedDeliveryChallans = []
        relatedDispatchNotes?.map(eachDispatchNote => {
            const relatedDeliveryChallan = deliveryChallans?.find(eachDeliveryChallan => eachDeliveryChallan?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
            if (relatedDeliveryChallan?.deliveryChallanId){
                relatedDeliveryChallans.push(relatedDeliveryChallan)
            }
        })

        let isAllPODsUploaded = false
        isAllPODsUploaded = relatedDeliveryChallans?.every(eachDeliveryChallan => eachDeliveryChallan?.docProof)

        let isNoInProcessQtyExists = true
        isNoInProcessQtyExists = buyerPOItems?.every(eachBuyerPOItem => {
            const relatedStockDoc = stocDocs?.find(eachStockDoc => eachStockDoc?.docNo == eachBuyerPOItem?.docNo && eachStockDoc?.materialId === eachBuyerPOItem?.materialId)
            return relatedStockDoc?.inProcessQty <= 0
        })
        if (isNoInProcessQtyExists){
            if (isAllPODsUploaded){ 
                if (remarks === ""){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please enter the remarks for force close.", life: 3000 }))
                }
                if (window.confirm("Do you want to force close the buyer PO...?")){
                    setIsLoading(true)
                    let updatedBuyerPOItems = buyerPOItems?.map(eachBuyerPOItem => {
                        const relatedStockDoc = stocDocs?.find(eachStockDoc => eachStockDoc?.docNo == eachBuyerPOItem?.docNo && eachStockDoc?.materialId === eachBuyerPOItem?.materialId)
                        return {...eachBuyerPOItem, pendingQty: relatedStockDoc?.pendingQty}
                    })
                    updatedBuyerPOItems = updatedBuyerPOItems?.filter(eachBuyerPOItem => eachBuyerPOItem?.pendingQty > 0)
                    const updatedRes = await forceCloseBuyerPO(buyerPOs[0]?.buyerPOId, {buyerPOItems: updatedBuyerPOItems, remarks: remarks})

                    if (updatedRes?.failure){
                        dispatch(raiseToast({ severity: 'error', summary: updatedRes?.data?.error, detail: "Buyer PO is Not Force Closed", life: 3000 }))
                    }else{
                        dispatch(raiseToast({ severity: 'success', detail: "Buyer PO has been Force Closed", life: 3000 }))
                        setIsForceCloseModalVisible(false)
                        dispatch(fetchBuyerPOs({...paginationParams, ...searchParams}))
                    }
                    setIsLoading(false)
                    setForseCloseRemarksDialogVisible(false)
                }
            }else{
                dispatch(raiseToast({ severity: 'warn', detail: "Please upload PODs for all related Delivery Challans and try again!", life: 3000 }))
            }
        }else{
            dispatch(raiseToast({ severity: 'warn', detail: "Please dispatch or convert inProcess quantities to stock and try again!", life: 3000 }))
        }
    }


    const handleSubmitIgnoreOpenPO = async (remarks) => {
        let data = {
            updatedObj: {
                ignoreOpenPO: true,
                remarks
            },
            buyerPOItemIds: selectedBuyerPOItemIds
        }
        setIsLoading(true)
        let updatedPOScheduleItemsResponse = await updatePOScheduleItemsByBuyerPOItemIds(data)
        console.log("updatedPOScheduleItems-response", updatedPOScheduleItemsResponse)
        setIsLoading(false)
        if(updatedPOScheduleItemsResponse.failure){
            return dispatch(raiseToast({ severity: 'error', summary: updatedPOScheduleItemsResponse.data?.error, life: 3000 }))
        }

        let buyerPOItemIds = buyerPOItems.map(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId)
        if(buyerPOItemIds.length){
            await getPOScheduleItems(buyerPOItemIds)
        }
        setSelectedBuyerPOItemIds([])
        setIgnoreOpenPORemarksDialogVisible(false)
    }

    const handleIgnoreOpenPORemarks = () => {
        if(selectedBuyerPOItemIds.length === 0){
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select buyer po items", life: 3000 }))
        }
        setIgnoreOpenPORemarksDialogVisible(prevState => !prevState)
    }

    const handleSelectAllBuyerPOItems = (event) => {
        if(event.checked){
            let relatedBuyerPOItems = _.uniq(_.map(_.filter(poScheduleItems, item => !item.ignoreOpenPO), 'buyerPOItemId'))
            let buyerPOItemIds = buyerPOItems
                                    .filter(eachBuyerPOItem => relatedBuyerPOItems.includes(eachBuyerPOItem.buyerPOItemId))
                                    .map(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId);

            setSelectedBuyerPOItemIds(buyerPOItemIds)
        }else{
            setSelectedBuyerPOItemIds([])
        }
    }

    const handleSelectBuyerPOItem = (event, selectedBuyerPOItemId) => {
        if(selectedBuyerPOItemIds.includes(selectedBuyerPOItemId)){
            let relatedBuyerPOItemIds = selectedBuyerPOItemIds.filter(eachBuyerPOItemId => eachBuyerPOItemId !== selectedBuyerPOItemId)
            setSelectedBuyerPOItemIds(relatedBuyerPOItemIds)
        }else{
            setSelectedBuyerPOItemIds([...selectedBuyerPOItemIds, selectedBuyerPOItemId])
        }
    }

    let canForceCloseBeDone = false
    canForceCloseBeDone = buyerPOItems?.some((eachBuyerPOItem, index) => {
        const relatedStockDoc = stocDocs?.find(eachStockDoc => eachStockDoc?.docNo == eachBuyerPOItem?.docNo && eachBuyerPOItem?.materialId === eachStockDoc?.materialId)
        let punchedQty = relatedStockDoc?.pendingQty + relatedStockDoc?.inProcessQty + relatedStockDoc?.invoicedQty + relatedStockDoc?.invoicePendingQty - relatedStockDoc?.CNDNQty
        return eachBuyerPOItem?.statusId === 3 //relatedStockDoc?.pendingQty && eachBuyerPOItem?.statusId === 3
    })

    let PODNotUploadedDeliveryChallans = relatedDeliveryChallans?.filter(eachDeliveryChallan => !eachDeliveryChallan?.docProof)

    let disabledSelectAll = false
    let selectAllCheckox = false
    if(buyerPOItems.length && poScheduleItems.length){
        disabledSelectAll = _.every(poScheduleItems, { ignoreOpenPO: true })

        let relatedBuyerPOItemIds = _.uniq(_.map(_.filter(poScheduleItems, item => !item.ignoreOpenPO), 'buyerPOItemId'))
        selectAllCheckox = selectedBuyerPOItemIds.length === relatedBuyerPOItemIds.length
    }
    
    return (
        <>  
            <p className="m-0">
                <span style={{ fontWeight: "bold" }}>Buyer PO No: </span><span className="ml-1">{buyerPOs[0]?.docNo} <CopyToClipboard text={buyerPOs[0]?.docNo} /></span>
                <span className="ml-5" style={{ fontWeight: "bold" }}> Buyer: </span>{buyerPOs[0]?.companies?.companyName}
            </p>
            {
                buyerPOs?.map(eachBuyerPO => {
                    return (
                        <div className="p-card mt-1">
                            <div className="flex flex-wrap py-2 w-full">
                                <div className="flex justify-content-between flex-grow-1 font-bold header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                    <div className="mb-2">
                                        <CheckboxField checked={selectAllCheckox} onChange={(event) => handleSelectAllBuyerPOItems(event)} disabled={disabledSelectAll} />
                                    </div>
                                    <div className="mb-2" style={{ width: '5%' }}>Sr No</div>
                                    <div className="mb-2" style={{ width: '20%' }}>Product</div>
                                    <div className="mb-2" style={{ width: '20%' }}>Specifications</div>
                                    <div className="mb-2" style={{ width: '10%' }}>Buyer PO Qty</div>
                                    <div className="mb-2" style={{ width: '10%' }}>InProcess Qty</div>
                                    <div className="mb-2" style={{ width: '10%' }}>Force Closing Qty</div>
                                </div>
                                {
                                    buyerPOItems?.map((eachBuyerPOItem, index) => {
                                        let relatedMaterialData = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerPOItem?.materialId)
                                        let relatedBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterialData?.brandId)
                                        let productName = relatedMaterialData?.companyProdName ? relatedMaterialData?.companyProdName : relatedMaterialData?.productName
                                        let productSpecification = relatedMaterialData?.companyProdSpec ? relatedMaterialData?.companyProdSpec : relatedMaterialData?.productSpecification
                                        let isIgnoreOpenScheduleItem = poScheduleItems.some(eachScheduleItem => eachScheduleItem.buyerPOItemId === eachBuyerPOItem.buyerPOItemId && eachScheduleItem.ignoreOpenPO)
                                        const relatedStockDoc = stocDocs?.find(eachStockDoc => eachStockDoc?.docNo == eachBuyerPOItem?.docNo && eachBuyerPOItem?.materialId === eachStockDoc?.materialId)
                                        let punchedQty = relatedStockDoc?.pendingQty + relatedStockDoc?.inProcessQty + relatedStockDoc?.invoicedQty + relatedStockDoc?.invoicePendingQty - relatedStockDoc?.CNDNQty
                                        return (
                                            <div className="flex justify-content-between flex-grow-1  w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                <div className="py-1 align-self-center">
                                                    <CheckboxField checked={selectedBuyerPOItemIds.includes(eachBuyerPOItem.buyerPOItemId)} onChange={(event) => handleSelectBuyerPOItem(event, eachBuyerPOItem.buyerPOItemId)} disabled={isIgnoreOpenScheduleItem} />
                                                </div>
                                                <div className="py-1 align-self-center" style={{ width: '5%' }}>{index+1}</div>
                                                <div className="py-1 align-self-center" style={{ width: '20%' }}>{relatedBrand?.brandName && `${relatedBrand?.brandName} - `} {productName} {relatedMaterialData?.variantName && ` - ${relatedMaterialData?.variantName}`}</div>
                                                <div className="py-1 align-self-center" style={{ width: '20%' }}>{productSpecification}</div>
                                                <div className="py-1 align-self-center" style={{ width: '10%' }}>{eachBuyerPOItem?.bPOQty}</div>
                                                <div className="py-1 align-self-center" style={{ width: '10%' }}>{relatedStockDoc?.inProcessQty}</div>
                                                <div className="py-1 align-self-center" style={{ width: '10%', textAlign: 'center' }}> 
                                                    <TextInputField name="forceClosingQty"  value={relatedStockDoc?.pendingQty} disabled />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
            <Loading visible={isLoading}/>
            {/* <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0" >
                    <TextAreaField name="remarks" labelText='Remarks' value={remarks} rows={4} cols={30} maxLength={100} onChange={(e) => setRemarks(e.target.value) }/>
                </div>
            </div> */}
            <div className='mt-3 flex justify-content-end'>
                <Button className="small-btn mb-1 mr-2" label="Ignore OpenPO" onClick={() => handleIgnoreOpenPORemarks()} disabled={!canForceCloseBeDone} permissions={[203]} />
                <Button className="small-btn mb-1" label="Force Close" onClick={() => setForseCloseRemarksDialogVisible(prevState => !prevState)} disabled={!canForceCloseBeDone}/>
                {/* <Button className="small-btn mb-1" label="Force Close" onClick={() => handleSubmit()} disabled={!canForceCloseBeDone}/> */}
            </div>
            <RemarksDialog header={"Ignore OpenPO Remarks"} placeholder={"Please enter remarks"} visible={ignoreOpenPORemarksDialogVisible} onHide={() => setIgnoreOpenPORemarksDialogVisible(prevState => !prevState)} onSubmit={handleSubmitIgnoreOpenPO}/>
            <RemarksDialog header={"Force Close Remarks"} placeholder={"Please enter remarks"} visible={forseCloseRemarksDialogVisible} onHide={() => setForseCloseRemarksDialogVisible(prevState => !prevState)} onSubmit={handleSubmit}/>
            {
                PODNotUploadedDeliveryChallans?.length > 0 &&
                <div className=''>
                    <div className="buyerpo-modal">
                        <div>
                            <div style={{width: '30%', marginTop: '3rem', marginLeft: ''}}>
                                <p className='font-bold'>POD Not Uploaded Delivery Challans</p>
                                <div className="custom-table-container">
                                    <table className="custom-product-table" style={{ width: "100%" }}>
                                        <thead>
                                            <tr className="">
                                                <th className="" >Sr. No</th>
                                                <th className="" >Delivery Challan Doc No.</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                            {
                                                PODNotUploadedDeliveryChallans?.map((eachDeliveryChallan, index) => {
                                                    return (
                                                        <tr className="">
                                                            <td className="">{index + 1}</td>
                                                            <td className="">{eachDeliveryChallan?.docNo}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ForceClose;